// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3XSqY","gfeWrapper":"CalendarEvent_gfeWrapper__1mW-b"};